export default __webpack_public_path__ + "static/media/triangle.a05cad32.mp3";